<template>
  <!-- Modal panel, show/hide based on modal state. -->
  <!--  :class="postsLoaded ? 'bg-white' : 'bg-truegray-500'" -->
  <div>
    <div v-if="postsLoaded" class="flex flex-col space-y-4 relative">
      <div class="flex space-x-6 items-end">
        <h2 class="m-0">Your posts</h2>
        <p
          :class="
            selectedPosts.length >= postsPerNewsletter
              ? 'text-red-400 font-semibold'
              : 'text-green-400'
          "
          :style="{ paddingBottom: '3px' }"
        >
          {{ selectedPosts.length }}/{{ postsPerNewsletter }}
          posts added
        </p>
      </div>

      <div class="w-full flex space-x-4 pt-2 justify-start">
        <!-- Search input -->
        <div
          class="h-12 w-full rounded relative bg-white border border-truegray-300"
        >
          <h6
            class="absolute transform duration-100 ease-linear px-1 left-3 top-1 z-40 text-truegray-700"
          >
            Search posts by title
          </h6>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 absolute right-2 bottom-1/2 transform translate-y-1/2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"
            />
          </svg>
          <input
            id="search_posts"
            v-model="search_posts"
            type="text"
            name="search_posts"
            autocomplete="search_posts"
            class="flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300"
          />
        </div>
        <button
          type="button"
          :disabled="submit_keywords_button_disabled"
          :class="[
            submit_keywords_button_disabled
              ? 'opacity-25 cursor-not-allowed btn-trans-black'
              : 'btn-black',
            thinkingPostsSearch ? 'btn-black cursor-not-allowed' : '',
          ]"
          class="btn m-0 relative h-12"
          @click="searchKeywords()"
        >
          <div
            class="absolute inset-0 w-full flex justify-center items-center z-20"
          >
            <lottie
              v-if="thinkingPostsSearch"
              :options="loadingAnimationOptions"
            />
          </div>
          <span :class="[thinkingPostsSearch ? 'invisible' : '']">Search</span>
        </button>
      </div>

      <!-- // POST Searched by keywords options -->
      <button
        v-if="postsLoaded && search_posts_active"
        type="button"
        class="flex-none justify-end mb-4 underline font-primary cursor-pointer hover:text-primary text-right mr-2"
        @click="resetKeywords()"
      >
        Reset Search
      </button>

      <div class="w-full pt-2 pb-8">
        <!-- Available posts -->
        <div
          class="transition-all duration-300 transform"
          :class="[
            postsLoaded
              ? 'translate-y-0 opacity-100'
              : 'translate-y-8 opacity-0',
          ]"
        >
          <div class="flex w-full flex-col">
            <div
              v-for="(item, i) in posts"
              :key="i"
              class="relative w-full p-2 px-4 flex justify-start items-start group cursor-pointer transition-all duration-100 ease-in-out"
              @click="updateSelectedPosts(item)"
            >
              <div
                class="w-5 h-5 border-2 mt-2 rounded-full flex items-center justify-center transition-background transition-border duration-300 ease-in-out"
                :class="
                  isSelected(item.id)
                    ? 'bg-green-400 border-green-400'
                    : 'border-gray-700'
                "
              >
                <svg
                  :class="isSelected(item.id) ? 'opacity-100' : 'opacity-0'"
                  :style="[{ left: '1px' }, { top: '1px' }]"
                  xmlns="http://www.w3.org/2000/svg"
                  class="relative h-5 w-5 text-white cursor-pointer transition-all duration-100"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="flex flex-col pl-4 w-full">
                <h5 class="font-primary truncate text-ellipsis">
                  {{ item.title }}
                </h5>
                <h6 class="text-truegray-500">
                  {{ item.created_at_ui }}
                </h6>
              </div>
            </div>
          </div>
        </div>

        <!-- post list pagination... -->
        <p v-if="postsLoaded && posts.length < 1" class="text-md">
          <!--
            ^^
            &&
            !search_posts_active 
          -->
          We could not find any posts...
        </p>
        <div
          v-if="post_pagination.previouspage || post_pagination.nextpage"
          class="flex justify-between items-center h-10"
        >
          <span
            :disabled="!post_pagination.previouspage"
            :class="[
              !post_pagination.previouspage
                ? 'opacity-25 cursor-not-allowed'
                : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
            ]"
            class="text-gray-500"
            @click="findNewsletterPosts(post_pagination.previouspage)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 17l-5-5m0 0l5-5m-5 5h12"
              />
            </svg>
          </span>
          <span class="text-center text-xs"
            >Page {{ post_pagination.current_page }} of
            {{ post_pagination.total_pages }}</span
          >
          <span
            :disabled="!post_pagination.nextpage"
            :class="[
              !post_pagination.nextpage
                ? 'opacity-25 cursor-not-allowed'
                : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
            ]"
            class="text-gray-500"
            @click="findNewsletterPosts(post_pagination.nextpage)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </span>
        </div>
      </div>
      <!-- Should probably be made into a component similar to the resource search!!!!!!!! -->
    </div>
    <div
      v-if="!postsLoaded"
      class="h-52 flex flex-col justify-center items-center"
    >
      <lottie :options="loadingAnimationOptions" />
      <span class="text-center">Loading posts</span>
    </div>

    <button
      v-if="postsLoaded"
      type="button"
      class="btn btn-trans-black"
      @click="closeModal"
    >
      Done
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../../../../shared/components/loading.json'

export default {
  props: {
    config: { default: null },
  },

  data() {
    return {
      loadingAnimationOptions: {
        animationData: loadingAnimation.default,
      },

      loadingAnimate: false,

      postsPerNewsletter: this.config?.postsPerNewsletter || 30,
      postsLoaded: false,
      // post_search_list : false,
      // post_search: [],
      search_posts: '',
      search_posts_active: false,
      thinkingPostsSearch: false,
      // submit_keywords_button_disabled : true,
      post_pagination: {
        current_page: null,
        total_pages: null,
        per_page: 10,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
        total: 0,
      },
    }
  },

  computed: {
    ...mapGetters({
      posts: 'careerwise/getNewsletterPosts',
      selectedPosts: 'careerwise/getNewsletterSelectedPosts',
    }),

    submit_keywords_button_disabled() {
      return this.search_posts.length > 0 ? false : true
    },
  },

  mounted: function () {
    this.findNewsletterPosts()
  },

  methods: {
    ...mapActions({
      dispatchUpdateSelectedNewsletterPosts:
        'careerwise/dispatchUpdateSelectedNewsletterPosts',
      dispatchGetNewsletterPosts: 'careerwise/dispatchGetNewsletterPosts',
    }),

    isSelected(id) {
      return !!this.selectedPosts.find((post) => post.id === id) // I am assured
    },

    updateSelectedPosts(post) {
      const posts = [...this.selectedPosts]
      const index = posts.findIndex((p) => p.id === post.id)
      if (index > -1) {
        posts.splice(index, 1)
      } else {
        posts.push(post)
      }
      this.dispatchUpdateSelectedNewsletterPosts(posts)
    },

    async findNewsletterPosts(value) {
      const payload = {
        page: value,
      }
      if (this.search_posts) {
        payload.search = { keywords: this.search_posts }
      }
      this.$set(this, 'postsLoaded', false)
      const pagination = await this.dispatchGetNewsletterPosts(payload)

      this.$set(
        this.post_pagination,
        'total_pages',
        Math.floor(pagination.total / pagination.per_page) + 1,
      )
      this.$set(this.post_pagination, 'current_page', pagination.current_page)
      this.$set(this.post_pagination, 'per_page', pagination.per_page)
      this.$set(this.post_pagination, 'last_page_url', pagination.last_page_url)
      this.$set(this.post_pagination, 'next_page_url', pagination.next_page_url)
      this.$set(this.post_pagination, 'prev_page_url', pagination.prev_page_url)
      this.$set(this.post_pagination, 'path', pagination.next_page_path)

      let prev = null
      if (this.post_pagination.prev_page_url) {
        prev = this.post_pagination.prev_page_url.split('=')
        prev = prev[1]
      }

      let next = null
      if (this.post_pagination.next_page_url) {
        next = this.post_pagination.next_page_url.split('=')
        next = next[1]
      }

      this.$set(this.post_pagination, 'previouspage', prev)
      this.$set(this.post_pagination, 'nextpage', next)

      this.$set(this, 'postsLoaded', true)
    },

    closeModal() {
      EventBus.$emit('showModal')
    },

    searchKeywords() {
      this.$set(this, 'search_posts_active', true)
      this.findNewsletterPosts()
    },

    resetKeywords() {
      this.$set(this, 'search_posts_active', false)
      this.$set(this, 'search_posts', '') // Reset the input field.
      this.findNewsletterPosts()
    },
  },
}
</script>
